module.exports = __webpack_public_path__ + "static/media/sample_1-01.1dee9fe7.jpg";